/** Pass on `<Link state={...} />` or `navigate(path, { state })` so forms can return to the opener. */
export const accountingReturnState = (pathname: string, search = '') => ({
  from: `${pathname}${search}`,
});
